class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cart = document.querySelector('cart-drawer');
  }

  toggleStickyAddToCartLoading() {
    $('#sticky-add-to-cart .sticky-add-to-cart__text').toggleClass('hidden')
    $('#sticky-add-to-cart .loading-overlay__spinner').toggleClass('hidden')
  }

  async onSubmitHandler(evt) {
    this.submitButton = this.querySelector('[type="submit"]');
    evt.preventDefault();

    if (this.submitButton.classList.contains('loading')) return;

    this.handleErrorMessage();

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    this.toggleStickyAddToCartLoading()

    await waitUntil(_ => !!this.cart.loading === false)

    const config = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    }

    const crossSellItems = getCrossSellProducts();
    if (crossSellItems.length > 0) {
      await requestCart({ items: crossSellItems });
    }

    const formData = new FormData(this.form);

    const variantId = formData.get('id');
    const quantity = formData.get('quantity') || 1 ;

    if (this.cart) {
      formData.append('sections', this.cart.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      this.cart.setActiveElement(document.activeElement);
    }

    //config.body = formData

    config.body = JSON.stringify({
      items: [
        {
          id: variantId,
          quantity
        },
      ],
      sections: this.cart.getSectionsToRender().map((section) => section.section)
    });

    const previousEmpty = $(this.cart).hasClass('is-empty')

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then(async (response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;

          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        this.error = false;

        const sections = this.cart.getSectionsToRender().map((section) => section.section)
        const sectionUrl = window.location.pathname

        const isGWP = false;
        //const { isGWP, state: cartWithGiftResponse } = await updateCartGift({ sections, sectionUrl })

        const quickAddModal = this.closest('quick-add-modal');

        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => {
              this.cart.renderContents(isGWP ? cartWithGiftResponse : response)
            });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(isGWP ? cartWithGiftResponse : response);
        }

        const cartRedeem = document.getElementById('CartRedeemCode');
        const cartSummary = document.getElementById('CartDrawerSummary');
        const codeRedeemed = cartRedeem.codeRedeemed

        if (previousEmpty) {
          $(this.cart).removeClass('is-empty')
        }

        if (!!codeRedeemed) {
          await this.cart.loadCheckout()

          const isApplicable = cartRedeem.checkCodeApplicable()

          if (!isApplicable) return

          cartSummary.computeDiscountedTotal()
          cartRedeem.refreshDiscountTag();
        }

        const UTMCode = sessionStorage.getItem('utm-code') || null;

        if (UTMCode) {
          await this.cart.loadCheckout();
          cartRedeem.renderDiscountTag();
          sessionStorage.removeItem('utm-code');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        this.toggleStickyAddToCartLoading()
      });
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', ProductForm);
}

document.addEventListener('DOMContentLoaded', function () {
  var splide = new Splide('#product-images-gallery', {
    arrows: false,
  });
  splide.mount();
});

var coll = document.querySelectorAll('#product-details-collapsible .collapsible');
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener('click', function () {
    this.classList.toggle('active');
    var content = this.nextElementSibling;
    var arrow = this.getElementsByClassName('collapsible-arrow')[0];
    if (content.style.display === 'block') {
      content.style.display = 'none';
      arrow.classList.remove('up');
      arrow.classList.add('down');
    } else {
      content.style.display = 'block';
      arrow.classList.remove('down');
      arrow.classList.add('up');
    }
  });
}